import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ArenaService {
  private httpClient = inject(HttpClient);

  /**
   * Create Arena
   * @param model 
   */
  create(model: any): Observable<any> {
    return this.httpClient.post(environment.platformUrl + "api/arena", model);
  }

  /**
   * Retrieve list of arenas.
   */
  getAll(): Observable<any> {
    return this.httpClient.get(environment.platformUrl + "api/arena");
  }
}
